// Types
import { RecipeFieldTypes } from "src/types/contentfulTypes";

// Contentful
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { documentToHtmlOptions } from "src/helpers/renderers/documentToHtmlOptions";

// Components
import RecipeSection from "src/components/organisms/recipeSection/RecipeSection";

// Styles
import "./RecipeSteps.scss";

interface RecipeIngredientsProps extends Pick<RecipeFieldTypes, "steps"> {}

const RecipeSteps = ({ steps }: RecipeIngredientsProps) => {
  return (
    <RecipeSection title="Steps">
      <div className="recipe-steps">
        {documentToReactComponents(steps, documentToHtmlOptions)}
      </div>
    </RecipeSection>
  );
};

export default RecipeSteps;
